module.exports = __webpack_public_path__ + "static/media/fondo_multimedia.f4d1a945.png";